import gql from 'graphql-tag';

const DEACTIVATE_LOCATION = gql`
  mutation deactivateLocation($id: ID!) {
    deactivateLocation(id: $id) {
      id
      name_en
    }
  }
`;

export default DEACTIVATE_LOCATION;
